export default "__VITE_ASSET__kaNlPr1f__$_?url__"